const classhourspend = {
  state: {
    addClassHourDialog: {
      title: '新增会员课包信息',
      type: 'add'
    },
    user: {
      username: '',
      name: '',
      telephone: ''
    },
    classHourSpendSearch: {
      username: "",
      year: "",
      month: "",
      date: ""
    }
  },
  getters: {
    addClassHourDialog: state => state.addClassHourDialog,
    user: state => state.user,
    classHourSpendSearch: state => state.classHourSpendSearch
  },
  mutations: {
    SET_CLASSHOUR_DIALOG_TITLE: (state, type) => {
      console.log('set-classhour-dialog-title')
      if (type === 'add') {
        state.addClassHourDialog.title = '新增会员课包信息'
        state.addClassHourDialog.type = 'add'
      } else {
        state.addClassHourDialog.title = '编辑会员课包信息'
        state.addClassHourDialog.type = 'edit'
      }
    },
    SET_CLASSHOUR_SPEND_SEARCH: (state, payload) => {
      state.classHourSpendSearch = payload
    },
    SET_USER: (state, payload) => {
      console.log('set_user')
      state.user = payload
    }
  },
  actions: {

  }
}

export default classhourspend